import { Link } from 'react-router-dom'

import './_terms.scss';

const DMCA = () => {

  return (
    <>
    <div className="pf-content pf-content--not-home">
      <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
              DMCA Policy
            </h2>
            <div className="pf-page__descr">
              <p>Last Updated: 2025/07/29</p>
            </div>
          <div className="pf-main-list">
            <h5 className="centered-h5">Termination of User Account</h5>
              <ol className="centered-ol">
                <li>We will terminate a user’s access to the service if, under appropriate circumstances, the user is 
                  determined to be a repeat infringer.</li>
                <li>We reserve the right to decide whether material or activity violates our <Link to="/terms" className='terms-link'>Terms of Service</Link> for 
                reasons other than copyright infringement, including child sexual abuse material (CSAM), obscenity, 
                  or excessive length. We may at any time, without prior notice, remove that material or terminate a 
                  user’s account for submitting that material in violation of our <Link to="/terms" className='terms-link'>Terms of Service</Link>.</li>
              </ol>
            <h5 className="centered-h5">Removal of Material for Which Copyright Infringement Is Claimed</h5>
            <h5 className="centered-h5">Digital Millennium Copyright Act</h5>
          
                <p>We will respond to allegations of copyright violations in accordance with the Digital Millennium 
                  Copyright Act (DMCA). The DMCA provides a process for a copyright owner to give notification to an 
                  online service provider concerning alleged copyright infringement. When an effective DMCA notification 
                  is received, the online service provider responds under this process by taking down the offending content. 
                  On taking down content under the DMCA, we will take reasonable steps to contact the owner of the removed 
                  content so that a Counternotification may be filed. On receiving a valid Counternotification, we generally 
                  restore the content in question, unless we receive notice from the DMCA Notice provider that a legal 
                  action has been filed seeking a court order to restrain the alleged infringer from engaging in the infringing 
                  activity. Our <Link to="/privacypolicy" className='terms-link'>Privacy Policy</Link> does not protect any information contained in any DMCA Counternotification.</p>
            
                <p><strong><span className="red-text">To File a DMCA Notification.</span> If you are a copyright owner or an agent of a copyright owner and believe 
                  that any Content infringes on your copyrights, you may submit a notification under the Digital Millenium 
                  Copyright Act (DMCA) by providing our copyright agent with the following information in writing (see 17 
                  U.S.C. § 512 for further detail):</strong></p>

                  <ol>
                    <li>
                      A physical or electronic signature of a person authorized to act for the owner of an exclusive 
                      right that is allegedly infringed.
                    </li>
                    <li>
                      Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single 
                      online site are covered by a single notification, a representative list of those works at that site.
                    </li>
                    <li>
                      Identification of the material that is claimed to be infringing or to be the subject of infringing 
                      activity and that is to be removed or access to which is to be disabled, and information reasonably 
                      sufficient to permit the service provider to locate the material. Providing URLs in the body of your 
                      DMCA notification is the best way to help us locate content quickly.
                    </li>
                    <li>
                      Information reasonably sufficient to permit us to contact you (the complaining party), including an address, telephone number, and, 
                      if available, an electronic mail address at which you (the complaining party) can be contacted.
                    </li>
                    <li>
                      A statement that you (the complaining party) have a good faith belief that use of the material in the manner complained 
                      of is not authorized by the copyright owner, its agent, or the law.
                    </li>
                    <li>
                      A statement that the information in the notification is accurate, and under penalty of perjury, that you 
                      (the complaining party) are authorized to act for the owner of an exclusive right that is allegedly infringed.
                    </li>
                    <li>
                      Provide information, if possible, sufficient to permit us to notify the user or users who posted the 
                      content that allegedly contains infringing material.
                    </li>
                  </ol>

                <p>You can send the DMCA Notice to our Designated Agent at:</p>
                
               <p>Innodev Solutions Inc.<br></br>
                2108 N ST, STE N<br></br>
                SACRAMENTO, CA 95816<br></br>
                dmca@allfans.com
                </p>

                <p><strong>Any person who knowingly materially misrepresents that material or an activity is infringing or that any 
                  material or activity was removed or disabled by mistake or misidentification, will be liable to us for 
                  any damages, including costs and legal fees incurred by us in removing or disabling access to the material 
                  or activity claimed to be infringing or in replacing the removed material or enabling access to it.</strong></p>
                <p><strong><span className="red-text">To File a Counternotification.</span> If you believe that your content/material that was removed or to which 
                  access was disabled is not infringing, or that you have the authorization from the copyright owner, the 
                  copyright owner’s agent, or under the law, to post and use the material, you may send a Counternotification 
                  containing the following information to our Designated Agent:</strong></p>
                    <ol>
                      <li>
                        Your physical or electronic signature;
                      </li>
                      <li>
                        Identification of the material that has been removed or to which access has been disabled and the 
                        location at which the material appeared before it was removed or access disabled;
                      </li>
                      <li>
                        A statement that you have a good faith belief that the material was removed or disabled as a 
                        result of mistake or a misidentification of the material; and
                      </li>
                      <li>
                        Your name, address, telephone number, and email address, a statement that you consent to the 
                        jurisdiction of the US district court in the state in which you reside (or the US District Court for 
                        the District of Nevada if your address is outside of the United States), and a statement that you will 
                        accept service of process from the person who provided notification of the alleged infringement to us.
                      </li>
                    </ol>
               <p>You can send the Counternotification to our Designated Agent at:</p>    
               <p>Innodev Solutions Inc.<br></br>
                2108 N ST, STE N<br></br>
                SACRAMENTO, CA 95816<br></br>
                dmca@allfans.com
               </p>
               <p><strong>Any person who knowingly materially misrepresents that material or an activity is infringing or 
                that any material or activity was removed or disabled by mistake or misidentification, will be liable 
                to us for any damages, including costs and legal fees incurred by us in removing or disabling access to the 
                material or activity claimed to be infringing or in replacing the removed material or enabling access to it.</strong></p>
              <div style={{ paddingTop: '240px' }}></div>
          </div>
        </div>


      </div>
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button> */}
{/*       <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default DMCA;
